import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from '@mui/material'
import { useBetContext } from 'contexts/BetContext'

export const AlertDialog = ({
    visible,
    onClose,
    title,
    description
}: {
    visible: boolean
    onClose?: () => void
    title?: string
    description: string
}) => {
    const { mainColor } = useBetContext()

    return (
        <Dialog
            open={visible}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {title && (
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            )}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    sx={{ backgroundColor: mainColor, color: 'white' }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
}
